import React from 'react';
import InfoTooltip from '../../../components/info-tooltip';

interface Props {
  schoolYear: string;
  borderTop: boolean;
  hasCourseYearWarning?: boolean;
}

const SchoolYearHeader = ({schoolYear, borderTop, hasCourseYearWarning}: Props) => (
  <div className={`course-school-year-header ${borderTop ? 'border-top' : ''}`}>
    <h4 className="course-school-year-header-text">{schoolYear}</h4>
    {hasCourseYearWarning && (
      <InfoTooltip blue>
        Depending on school guidelines courses taken over ten years ago may or may not be eligible
        for micro-scholarships.
      </InfoTooltip>
    )}
  </div>
);

export default SchoolYearHeader;
